import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $AdditionalInformationDidacticsContainer = styled.div`
  padding-bottom: ${spacing('lg')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('sm')};
`;
